import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardBadgeArea } from './PropertyCardBadgeArea.styles';

/**
 * A container for the badge in a `PropertyCard`.
 *
 * @since 8.67.
 */
export var PropertyCardBadgeArea = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardBadgeArea, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardBadgeArea.displayName = 'PropertyCard.BadgeArea';